import moment from 'moment'

export class GetCurrentDate {
  public execute() {
    return moment()
  }
}
